import { compose, withProps } from 'recompose'
import Flexbox from 'flexbox-react'
import PropTypes from 'prop-types'
import React from 'react'
import injectSheet from 'react-jss'

function Flexblock(props) {
	return (
		<Flexbox {...props}>
			<div style={{ display: 'block', width: '100%' }}>{props.children}</div>
		</Flexbox>
	)
}
// https://github.com/yannickcr/eslint-plugin-react/issues/7#issuecomment-90294004
Flexblock.propTypes = {
	children: PropTypes.node
}
Flexblock.defaultProps = {
	children: null
}

/**
 * Known bugs (features?) RE:loading overlay:
 * * Stretches entire screen
 * * Can click through on submit
 */
const FlexViewer = compose(
	injectSheet({
		// Always have the overlay positioned so we can animate fade
		overlay: {
			position: 'absolute',
			top: 0,
			right: 0,
			left: 0,
			bottom: 0,
			opacity: '0',
			'z-index': -1,
			transition: 'all 0.5s ease-in-out'
		},
		// But only really display when overlaying
		overlayed: {
			'background-color': 'black',
			opacity: '0.5',
			'z-index': 9999999
		}
	})
)(props => {
	const { submitting, classes, children } = props

	return (
		<Flexblock flexGrow={1} style={{ overflowY: 'auto', overflowX: 'hidden' }}>
			<div className={`${classes.overlay} ${submitting ? classes.overlayed : false}`} />
			{children}
		</Flexblock>
	)
})
FlexViewer.propTypes = {
	children: PropTypes.node,
	classes: PropTypes.arrayOf(PropTypes.string),
	submitting: PropTypes.bool
}

export default {
	Container: withProps({
		flexDirection: 'column',
		style: { position: 'absolute', top: '0', bottom: '0', right: '0', left: '0' }
	})(Flexbox),

	Sticker: withProps({
		// Work-around for https://github.com/nachoaIvarez/flexbox-react/issues/35
		// TODO: Put back to flexShrink prop instead when issue is resolved
		style: { flexShrink: 0 },
		width: '100%'
	})(Flexblock),

	Grower: withProps({
		flexGrow: 1,
		style: { overflow: 'hidden' }
	})(Flexblock),

	Viewer: FlexViewer
}



// WEBPACK FOOTER //
// ./src/components/Layout.js